import { IconButton, Stack, Badge, Popover, Box, InputBase } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";

export default function ExpedienteEntradaFilter({ filtraentradas }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>

          <form style={{ display: 'flex', }}>
            <InputBase
              style={{ width: '70%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20 }}
              sx={{ ml: 1, flex: 1 }}
              autoFocus
              placeholder="Filtro"
              inputProps={{ 'aria-label': 'Filtrar lista' }}
              onChange={(e) => { filtraentradas(e.target.value) }}
            />
          </form>

          {/* <Box mt={2} display="flex" justifyContent="flex-end">
            <Button size="small" onClick={handleClear}>
              Limpar
            </Button>
          </Box> */}
        </Box>
      </Popover>
    </Stack>
  );
};


